export const ASTERISK = String.fromCharCode(42); // "*"
export const DEFAULT_FONT = "Roboto";
export const EMPTY_VALUE_DASH = String.fromCharCode(0x2014); // "—"
export const MAX_VEHICLES = 6;
